import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
  Optional,
} from '@angular/core';
import {
  ARTICLE_BLOCK_MAX_IMAGE_HEIGHT,
  ArticleBlockComponent,
} from '@tisa-group/client-ui/components/article-block';
import {ImageVariantPipe} from '@tisa-group/core';

@Component({
  selector: 'tisa-article-block-image',
  templateUrl: './article-block-image.component.html',
  styleUrls: ['article-block-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ImageVariantPipe],
  standalone: false,
})
export class ArticleBlockImageComponent {
  @HostBinding('class')
  readonly className = 'block overflow-hidden';

  get maxImageHeight(): string {
    return `${this.articleBlockMaxImageHeight}px`;
  }

  get image(): string | undefined {
    return this.articleBlockComponent?.article?.image;
  }

  get isPremium(): boolean | undefined {
    return this.articleBlockComponent?.article?.isPremium;
  }

  get link(): string | undefined {
    return this.articleBlockComponent?.link;
  }

  constructor(
    @Optional()
    @Inject(ARTICLE_BLOCK_MAX_IMAGE_HEIGHT)
    readonly articleBlockMaxImageHeight: number | undefined,
    @Optional()
    @Inject(ArticleBlockComponent)
    readonly articleBlockComponent: ArticleBlockComponent | undefined,
  ) {}
}
